import clsx from "clsx";
import { merosZustandLabel, type MerosZustand } from "@/lib/meros";

export function MerosAbweichungBadge({
  ist,
}: {
  ist?: MerosZustand | null;
}) {
  const steht = ist === "oben" || ist === "unten" ? merosZustandLabel(ist) : null;
  return (
    <span
      className="inline-flex items-center rounded-full bg-status-orange/15 px-2 py-0.5 text-xs font-semibold text-status-orange"
      title={
        steht
          ? `Eingetragener Stand ist ${steht} und passt nicht zu diesem Termin.`
          : "Der eingetragene Stand passt nicht zu diesem Termin."
      }
    >
      {steht ? `Passt nicht · steht ${steht}` : "Passt nicht"}
    </span>
  );
}

export function MerosZustandBadge({
  zustand,
  prefix = "Merostützen",
  size = "sm",
}: {
  zustand: MerosZustand | null | undefined;
  prefix?: string;
  size?: "sm" | "lg";
}) {
  if (zustand !== "oben" && zustand !== "unten") return null;
  const oben = zustand === "oben";
  return (
    <span
      className={clsx(
        "inline-flex rounded-full font-semibold tracking-wide",
        size === "lg" ? "px-3 py-1 text-lg" : "px-2 py-0.5 text-xs",
        oben ? "bg-accent-soft text-accent" : "bg-fill-secondary text-label",
      )}
    >
      {prefix ? `${prefix} ` : ""}
      {merosZustandLabel(zustand)}
    </span>
  );
}
